import { SpinningLoader } from '@frontend/design-system';
import { EmptyStateGraphic } from '../../empty-state';

export const ThreadViewStateIndicator = ({ state }: { state: 'loading' | 'empty' }) => {
  return (
    <div css={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {state === 'loading' ? <SpinningLoader /> : <EmptyStateGraphic />}
    </div>
  );
};
